import React from "react"
import {useAppDispatch} from "../../../hooks/redux"
import IconButton from "../../generic/buttons/IconButton"
import Notification from "../../blocks/Notification"
import UserPanel from "./components/UserPanel"
import {logout} from "../../../store/actions/authActions"
import Breadcrumbs from "../../generic/navigation/Breadcrumbs"
import {IBreadCrumbs} from "../../../models"
import useWindowSize from "../../../hooks/useWindowSize"
import classes from "./Header.module.scss"

interface IHeaderProps {
  title?: string,
  showUser?: boolean
  breadcrumbs?: IBreadCrumbs
  isLoading?: boolean
}

export default function Header({title, showUser, breadcrumbs, isLoading}: IHeaderProps) {

  const dispatch = useAppDispatch()
  const windowSize = useWindowSize()

  const logoutHandler = async () => {
    await dispatch(logout())
  }

  return (
    <header className={classes.wrap}>
      <div>
        {title && <h1 className={classes.title}>{title}</h1>}
        {
          breadcrumbs && !isLoading &&
          <Breadcrumbs breadcrumbs={breadcrumbs}/>
        }
      </div>
      <div className={classes.controls}>
        {showUser && windowSize.width >= 1200 &&
          <div className={classes.user}>
            <UserPanel/>
          </div>
        }
        <Notification/>
        {windowSize.width >= 1200 && <IconButton color={"white"} className={classes.logout} onClick={logoutHandler} icon={'power'} />}
      </div>
    </header>
  )
}